module.exports = {
          srcSet: __webpack_public_path__ + "d0544b1301ba36057ffc641eee1660a6-3076.png"+" 3076w",
          images:[ {path: __webpack_public_path__ + "d0544b1301ba36057ffc641eee1660a6-3076.png",width: 3076,height: 320}],
          src: __webpack_public_path__ + "d0544b1301ba36057ffc641eee1660a6-3076.png",
          toString:function(){return __webpack_public_path__ + "d0544b1301ba36057ffc641eee1660a6-3076.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAABCAIAAABol6gpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAJ0lEQVR4nGNQtw1VtQpSMfNTMfVRMfVSNnJXNHBR0HWQ07KV1bACAGNVBh3QntKAAAAAAElFTkSuQmCC",
          width: 3076,
          height: 320
        }